import axios from "axios";
import { getCookie } from "../utils/cookieUtils";

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: "https://www.sfwarehouse.app/api", // Replace with your API base URL
  timeout: 30000, // Request timeout in milliseconds
  headers: {
    "Content-Type": "application/json",
    // withCredentials: true,
    // "Access-Control-Allow-Origin": "*",
  },
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Add authorization token or other custom headers if needed
    const token = getCookie("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // Handle request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    // Handle successful response
    return response;
  },
  (error) => {
    // Handle response error
    if (error.response && error.response.status === 401) {
      // Handle unauthorized error (e.g., redirect to login)
      console.error("Unauthorized, redirecting to login...");
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
